import { TenantAppShell } from '@/app/tenant-app-shell';

import './app.css';
import { router } from './app.router';

function App() {
	return <TenantAppShell router={router} />;
}

export default App;
